export const formatDate = (timestamp) => {  
  const date = new Date(timestamp);

  // Use the browser's locale settings for a user-friendly format
  const formattedDate = date.toLocaleDateString('id-ID', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return formattedDate;
};